import {WALL} from '@/config/config'
import {PERMS} from '@/config/permissions'
import permissionsHelper from '../utils/permissionsHelper.js'
import { PERMISSION_MODULE_IDS } from '@/config/permissions'

export default {
  computed: {
    moduleIds() {
      return PERMISSION_MODULE_IDS
    },
    userCanDelete () {
      return this.$sharedServices.store.getters.userCan(PERMS.DELETE, {route: this.$sharedServices.router.history.current})
    },
    userCanCreate () {
      return this.$sharedServices.store.getters.userCan(PERMS.CREATE, {route: this.$sharedServices.router.history.current})
    },
    userCanEdit () {
      return this.$sharedServices.store.getters.userCan(PERMS.EDIT, {route: this.$sharedServices.router.history.current})
    },
    userCanWrite () {
      let route = this.$sharedServices.router.history.current
      if (route.params && route.params.id) {
        return this.userCanEdit
      // if non-standart update route
      } else if (this.fields && this.fields.id) {
        return this.userCanEdit
      // in map update relation
      } else if (this.id) {
        return this.userCanEdit
      }
      return this.userCanCreate
    }
  },
  methods: {
    userHavePermission (type, route = null) {
      if (!route) {
        route = this.$sharedServices.router.history.current
      }
      return this.$sharedServices.store.getters.userCan(type, {route: route})
    },
    userHavePermissionEx (type, route = null) {
      if (!route) {
        route = this.$sharedServices.router.history.current
      }
      if (this.userHavePermission(type, route) === false) {
        this.$swal({
          position: 'center',
          type: 'error',
          title: permissionsHelper.getUserFriendlyMessage(type, route),
          showConfirmButton: false,
          timer: WALL.ERROR_TIMEOUT
        })
        return false
      }
      return true
    }
  }
}
